export enum AlertTypes  {
    Success = 'Success',
    Fail = 'Danger',
    Alert = 'Alert',
};
